import DateFormattingStrategy from './DateFormattingStrategy'
import {EvaDateQualifier} from 'constants'
import messageResource from '../messageResource'

export default class SingleDateFormattingStrategy extends DateFormattingStrategy {
    formatForDateInformation(dateParameters) {
        const dateSelection = dateParameters.dateSelection

        const qualifier = dateSelection.qualifier
        const date = dateSelection.date

        let dateString
        if (qualifier === EvaDateQualifier.CUSTOM) {
            dateString = this.formatDate(date)
        } else {
            dateString = ((qualifier === EvaDateQualifier.TODAY || qualifier === EvaDateQualifier.YESTERDAY) ?
                          "" : (messageResource.getMessage("common.pdf.formatting.date.the") + " ")) +
                         messageResource.getMessage(EvaDateStateUtil[qualifier]).toLowerCase()
        }

        return messageResource.getMessage("common.pdf.formatting.date.date_part.single", [dateString])
    }

    formatSpecifyingInformation(dateParameters) {
        const dateSelection = dateParameters.dateSelection

        if (dateSelection.qualifier === EvaDateQualifier.CUSTOM)
            return ""

        return " (" + this.formatDate(dateSelection.date) + ")"
    }
}



// WEBPACK FOOTER //
// ./web/js/parametersFormatting/SingleDateFormattingStrategy.js